<template>
  <!-- ログイン済みの場合に使用するレイアウト -->
  <div class="flex h-screen min-w-[640px]">
    <component :is="currentLayout" />
    <Jiji class="fixed bottom-[3%] left-[3%] z-20" :should-show="shouldShowEnvText" :text="envText" />
    <Toast />
    <main class="ml-48 flex min-h-screen flex-1 overflow-x-hidden p-6 pb-0">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import Jiji from '@/components/atoms/icon/Jiji/Jiji.vue';
import Toast from '@/components/atoms/layout/Toast/Toast.vue';
import Sidebar from '@/components/organisms/Sidebar.vue';
import WabunkaSidebar from '@/components/organisms/WabunkaSidebar.vue';
import { PERSIST_KEY_LIST, stateFactory } from '@/utils/state';
const runtimeConfig = useRuntimeConfig();

// もうちょっと良い置き場があるかも
// アプリケーションの初期化時にのみ1回実行されれば良い
PERSIST_KEY_LIST.forEach((key) => {
  stateFactory.restore(key);
});

const envText = computed<string>(() => {
  if (runtimeConfig.public.ENV === 'local') return 'ローカル環境';
  if (runtimeConfig.public.ENV === 'development') return '検証環境';
  return '';
});

const shouldShowEnvText = computed<boolean>(() => {
  return runtimeConfig.public.ENV === 'local' || runtimeConfig.public.ENV === 'development';
});
const route = useRoute();
const currentLayout = computed(() => {
  return route.path.startsWith('/wabunka') ? WabunkaSidebar : Sidebar;
});
</script>
